import { z } from 'zod';
/**
 * Kaizen — qualidade de peças e fornecedores: o "laboratório de inspeção
 * técnica de peças" do A3 (contramedida 2) e a gestão de fornecedores com
 * SLA (roadmap, médio prazo). A reincidência por peça e por fornecedor é o
 * que alimenta a conversa de garantia e de contrato.
 */
export const createSupplierSchema = z.object({
    name: z.string().trim().min(2, 'Informe o nome').max(120),
    cnpj: z.string().trim().max(18).optional(),
    contact: z.string().trim().max(160).optional(),
    claimSlaDays: z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), z.coerce.number().int().min(0).optional()),
});
export const updateSupplierSchema = createSupplierSchema.partial().extend({ isActive: z.boolean().optional() });
export const PartInspectionResult = { APPROVED: 'APPROVED', REJECTED: 'REJECTED' };
export const PART_REJECTION_REASONS = {
    DEFEITO_FABRICACAO: 'Defeito de fabricação',
    FORA_DE_ESPEC: 'Fora da especificação',
    DANO_TRANSPORTE: 'Dano de transporte / embalagem',
    FALHA_PREMATURA: 'Falha prematura em uso',
    DESGASTE_NORMAL: 'Desgaste normal (não é defeito)',
    OUTRO: 'Outro',
};
export const WARRANTY_CLAIM_LABELS = {
    NONE: 'Sem reclamação',
    OPENED: 'Reclamação aberta',
    ACCEPTED: 'Aceita pelo fornecedor',
    DENIED: 'Negada',
};
export const createPartInspectionSchema = z.object({
    materialId: z.string().uuid('Selecione a peça'),
    supplierId: z.preprocess((v) => (v === '' ? undefined : v), z.string().uuid().optional()),
    workOrderId: z.preprocess((v) => (v === '' ? undefined : v), z.string().uuid().optional()),
    vehicleId: z.preprocess((v) => (v === '' ? undefined : v), z.string().uuid().optional()),
    serialNumber: z.string().trim().max(64).optional(),
    quantity: z.coerce.number().positive().default(1),
    result: z.nativeEnum(PartInspectionResult),
    reason: z.enum(Object.keys(PART_REJECTION_REASONS)),
    kmInService: z.preprocess((v) => (v === '' || v === null || v === undefined ? undefined : v), z.coerce.number().int().min(0).optional()),
    underWarranty: z.boolean().default(false),
    claimStatus: z.enum(Object.keys(WARRANTY_CLAIM_LABELS)).default('NONE'),
    note: z.string().trim().max(500).optional(),
});
export const updatePartInspectionSchema = z.object({
    claimStatus: z.enum(Object.keys(WARRANTY_CLAIM_LABELS)),
    note: z.string().trim().max(500).optional(),
});
//# sourceMappingURL=quality.schemas.js.map